import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { ArrowLeft, Info } from "lucide-react";

interface PhaseNavigationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  fromPhase: string;
  toPhase: string;
  description?: string;
}

export const PhaseNavigationDialog = ({
  open,
  onOpenChange,
  onConfirm,
  fromPhase,
  toPhase,
  description,
}: PhaseNavigationDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <ArrowLeft className="w-5 h-5 text-primary" />
            Zurück zu {toPhase}?
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <p>
              Du wechselst von <span className="font-medium text-foreground">{fromPhase}</span> zurück zu{" "}
              <span className="font-medium text-foreground">{toPhase}</span>.
            </p>
            
            <div className="flex items-start gap-2 p-3 bg-primary/5 border border-primary/10 rounded-lg">
              <Info className="w-4 h-4 text-primary mt-0.5 flex-shrink-0" />
              <p className="text-sm text-foreground">
                Keine Sorge – deine bisherigen Eingaben bleiben erhalten. Du kannst jederzeit zwischen den Phasen wechseln, ohne Daten zu verlieren.
              </p>
            </div>

            {description && (
              <p className="text-sm text-muted-foreground">{description}</p>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Abbrechen</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            Zu {toPhase} wechseln
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
